import { Observable } from 'rxjs';
import { MessageBoxContent, MessageBoxStyle } from './message-box-content';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageBoxDialogComponent } from './message-box.dialog.component';

@Injectable({
  providedIn: 'root'
})
export class MessageBoxService {

  public width: string = '500px';

  constructor(private dialog: MatDialog) {
  }

  public showObservable(message: MessageBoxContent): Observable<any> {

    return this.dialog.open(MessageBoxDialogComponent, {
        backdropClass: 'custom-overlay-pane-class',
        width: this.width,
        data: message
      }).afterClosed();
  }

  public async show(message: MessageBoxContent): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.dialog.open(MessageBoxDialogComponent, {
        backdropClass: 'custom-overlay-pane-class',
        width: this.width,
        data: message
      }).afterClosed().subscribe(result => resolve(result));
    });
  }

  public async showSimple(dataPrefix: string, yesButton?: string): Promise<any> {

    const mdc = <MessageBoxContent>{
      style: MessageBoxStyle.Normal,
      title: dataPrefix + '.title',
      text: dataPrefix + '.text',
      yesButton: yesButton || 'common.ok'
    };

    return this.show(mdc);
  }

  public async showComplex(message: MessageBoxContent): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.dialog.open(MessageBoxDialogComponent, {
        backdropClass: 'custom-overlay-pane-class',
        width: '800px',
        data: message
      }).afterClosed().subscribe(result => resolve(result));
    });
  }
}
